module.exports = __webpack_public_path__ + "static/media/who-12.a8637544.jpg";